module.exports = __webpack_public_path__ + "static/img/ls2.c010496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls2.png
// module id = WzC2
// module chunks = 12